module.exports = __webpack_public_path__ + "files/014b8cbdc5a7a361d1750d0c87effa8a.svg";